const getSelectedOptionData = (optionsData) => optionsData.find(x => x.get('selected'));

export {getSelectedOptionData}